module.exports = __webpack_public_path__ + "img/logo.6802cb49.jpg";